import { Component, input } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { TranslocoModule } from '@ngneat/transloco';

import { BaseSectionComponent } from '../../base-classes/sections/base-section.component';
import { SelectItem } from '../../models/select-item.type';
import { SectionWrapperComponent } from '../containers/section-wrapper-container/section-wrapper-container.component';
import { SingleDropdownComponent } from '../dropdowns/single-dropdown/single-dropdown.component';
import { SingleRadioComponent } from '../dropdowns/single-radio/single-radio.component';

class RecordModel {
	id: number;
	type: unknown;
}

@Component({
	selector: 'app-type-section',
	templateUrl: 'type-section.component.html',
	imports: [
		SectionWrapperComponent,
		SingleRadioComponent,
		ReactiveFormsModule,
		TranslocoModule,
	],
})
export class TypeSectionComponent<T> extends BaseSectionComponent<RecordModel> {
	protected _skipCount: number = 0;
	options = input<SelectItem<unknown>>();
	constructor(private _formBuilder: FormBuilder) {
		super();
		this.detailsForm = this._formBuilder.group({
			type: [null],
		});
	}

	protected _mapModelToForm(): void {
		const detailsFormData: any = {
			type: this.recordData().type,
		};
		this.detailsForm.setValue(detailsFormData, {
			emitEvent: false,
		});
	}
	protected _mapFormToModel(): Partial<RecordModel> {
		return {
			type: this.detailsForm.value.type,
		};
	}
}
